import { useEffect, useRef, useCallback } from 'react';

function validateShortcut(shortcut) {
    if (typeof shortcut !== 'object' || shortcut === null) {
        throw new Error('Each shortcut must be an object');
    }
    if ('code' in shortcut && typeof shortcut.code !== 'string') {
        throw new Error('shortcut.code must be a string');
    }
    if (typeof shortcut.handleClick !== 'function') {
        throw new Error('shortcut.handleClick must be a function');
    }
}

function matchesShortcutCode(shortcutCode, eventCode) {
    if (!shortcutCode) return true;
    if (shortcutCode === eventCode) return true;

    const shortcutDigit = shortcutCode.match(/^(?:Digit|Numpad)(\d)$/)?.[1];
    const eventDigit = eventCode?.match(/^(?:Digit|Numpad)(\d)$/)?.[1];

    return Boolean(shortcutDigit && eventDigit && shortcutDigit === eventDigit);
}

const useKeyNavigation = (shortcuts = [], shouldExecute = true) => {
    if (!Array.isArray(shortcuts)) {
        throw new Error('shortcuts must be an array');
    }
    shortcuts.forEach(validateShortcut);

    const shortcutsRef = useRef(shortcuts);
    shortcutsRef.current = shortcuts;

    const handleKeyDown = useCallback((e) => {
        shortcutsRef.current.forEach(({ code, altKey = false, shiftKey = false, ctrlKey = false, metaKey = false, handleClick }) => {
            const match =
                altKey === e.altKey && shiftKey === e.shiftKey && ctrlKey === e.ctrlKey && metaKey === e.metaKey && matchesShortcutCode(code, e.code);

            if (match) {
                e.preventDefault();
                handleClick();
            }
        });
    }, []);

    const handleKeyAltUp = useCallback((e) => {
        if (e.key === 'Alt') {
            e.preventDefault();
        }
    }, []);

    useEffect(() => {
        if (!shouldExecute) return;
        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener('keyup', handleKeyAltUp);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            window.removeEventListener('keyup', handleKeyAltUp);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldExecute]);
};

export default useKeyNavigation;
